// extracted by mini-css-extract-plugin
module.exports = {"root":"CountryFlag_root__yXjCt"};